export default __webpack_public_path__ + "browser-samsung-internet.png";